module.exports = __webpack_public_path__ + "static/dummie-5f4323ea33875da5d72c00caa0d3460d.jpg";